// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"_3_dQhX","title":"_2RKegk","menuContainer":"_2PE3WK","container":"_2VBsNS","menuItemLink":"_1IGiHf","submenu":"_24coc0"};